const agentAttorneyView = (data) => {
    let formData = data && data.getAgentProfileById && data.getAgentProfileById.AgentProfileFormData
    if(formData){  
        let view = {
            name: formData.new_profile_atty_agent_profile_name,
            sections: [
                {
                    name: 'Agent/Attorney - Indentifiers',
                    fields: [
                        {
                            number: 1,
                            label: 'Law Firm/Business Name',
                            value: formData.new_profile_atty_agent_dba,

                        },
                        {
                            number: 2,
                            label: 'FEIN',
                            value: formData.new_profile_atty_agent_fein,
                        },
                    ]
                }
            ]
        }
        return view;
    }
}

export default agentAttorneyView